import React, { useState } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { useLeague } from "../hooks/useLeague";
import MobileUserProfile from "../Common/MobileUserProfile";
import "./LeaguePublic.css";

export default function PublicNavbar() {
  const { currentLeague } = useLeague();
  const { abbr } = useParams<{ abbr: string }>();
  const [showMenu, setShowMenu] = useState(false);

  const handleClose = () => setShowMenu(false);
  const handleShow = () => setShowMenu(true);

  // Close menu on navigation
  const handleLinkClick = () => {
    setShowMenu(false);
  };

  // Base path for the current league
  const basePath = `/leagues/${abbr || currentLeague?.abbr || ""}`;

  return (
    <header className="lp-header">
      <div className="lp-header-top">
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {currentLeague ? (
            <Link to={basePath} className="lp-brand">
              <span className="lp-brand-mark" aria-hidden="true">
                <i className="bi bi-bar-chart-steps" />
              </span>
              <span className="lp-brand-name">{currentLeague.name}</span>
            </Link>
          ) : (
            <Link to="/" className="lp-brand">
              <span className="lp-brand-mark" aria-hidden="true">
                <i className="bi bi-bar-chart-steps" />
              </span>
              <span className="lp-brand-name">Podium</span>
            </Link>
          )}
        </div>

        <div className="lp-header-actions">
          {/* Desktop Navigation */}
          <nav className="lp-nav-desktop" aria-label="League sections">
            <NavLink
              to={basePath}
              end
              className={({ isActive }) =>
                `lp-nav-link-inline${isActive ? " active" : ""}`
              }
            >
              Home
            </NavLink>
            <NavLink
              to={`${basePath}/standings`}
              className={({ isActive }) =>
                `lp-nav-link-inline${isActive ? " active" : ""}`
              }
            >
              Standings
            </NavLink>
            <NavLink
              to={`${basePath}/schedule`}
              className={({ isActive }) =>
                `lp-nav-link-inline${isActive ? " active" : ""}`
              }
            >
              Schedule
            </NavLink>
            <NavLink
              to={`${basePath}/stats`}
              className={({ isActive }) =>
                `lp-nav-link-inline${isActive ? " active" : ""}`
              }
            >
              Stats
            </NavLink>
            <Link to="/admin" className="lp-btn-ghost lp-admin-link">
              Admin dashboard
            </Link>
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            className="lp-hamburger d-md-none"
            onClick={handleShow}
            aria-label="Open menu"
          >
            <i className="bi bi-list" />
          </button>
        </div>
      </div>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas
        show={showMenu}
        onHide={handleClose}
        placement="end"
        className="lp-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {currentLeague ? (
              <span className="lp-league-name">{currentLeague.name}</span>
            ) : (
              <div className="lp-brand">
                <span className="lp-brand-mark" aria-hidden="true">
                  <i className="bi bi-bar-chart-steps" />
                </span>
                <span className="lp-brand-name">Podium</span>
              </div>
            )}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <nav className="lp-nav-mobile">
            <NavLink
              to={basePath}
              end
              className={({ isActive }) =>
                `lp-nav-mobile-link${isActive ? " active" : ""}`
              }
              onClick={handleLinkClick}
            >
              <i className="bi bi-house me-2" />
              Home
            </NavLink>
            <NavLink
              to={`${basePath}/standings`}
              className={({ isActive }) =>
                `lp-nav-mobile-link${isActive ? " active" : ""}`
              }
              onClick={handleLinkClick}
            >
              <i className="bi bi-list-ol me-2" />
              Standings
            </NavLink>
            <NavLink
              to={`${basePath}/schedule`}
              className={({ isActive }) =>
                `lp-nav-mobile-link${isActive ? " active" : ""}`
              }
              onClick={handleLinkClick}
            >
              <i className="bi bi-calendar3 me-2" />
              Schedule
            </NavLink>
            <NavLink
              to={`${basePath}/stats`}
              className={({ isActive }) =>
                `lp-nav-mobile-link${isActive ? " active" : ""}`
              }
              onClick={handleLinkClick}
            >
              <i className="bi bi-graph-up me-2" />
              Stats
            </NavLink>
            <div className="lp-nav-divider" />
            <Link
              to="/admin"
              className="lp-nav-mobile-link lp-nav-mobile-link-primary"
              onClick={handleLinkClick}
            >
              <i className="bi bi-speedometer2 me-2" />
              Admin dashboard
            </Link>
            <MobileUserProfile onLinkClick={handleLinkClick} />
          </nav>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
}
